const firmIds = [
  'alpha-capital',
  'cti',
  'fxify',
  'ttp',
  'e8',
  'for-traders',
  'seacrest-funded',
  'tradingplus',
  'wmt',
  'blueberryfunded',
  'blueguardian'
  // Add all your firm IDs here
];

export const loadFirmData = async (id: string) => {
  const profile = await import(`./firms/${id}/profile.json`);
  const discountImport = await import(`./firms/${id}/discount.json`);
  const rawPricing = await import(`./firms/${id}/pricing.json`);
  const pricing = Array.isArray(rawPricing.default) ? rawPricing.default : rawPricing.pricing || [];
  const details = await import(`./firms/${id}/details.json`);

  const discounts = Array.isArray(discountImport.default) ? discountImport.default : [discountImport.default];

  return {
    id,
    ...profile,
    discounts,
    pricing,
    details,
  };
};

export const loadAllFirms = async () => {
  const data = await Promise.all(
    firmIds.map(async (id) => {
      const firmData = await loadFirmData(id);
      return firmData;
    })
  );

  return data;
};

export const loadAllPropFirmData = async () => {
  const data = await Promise.all(
    firmIds.map(async (id) => {
      const firm = await loadFirmData(id);
      return [id, firm];
    })
  );
  return Object.fromEntries(data);
};
